"use client";
import React, { useState, useEffect } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import right from "../../../public/updated-home/about/right-arrow.svg";
import left from "../../../public/updated-home/about/left-arrow.svg";
import Vision1 from "../../../public/updated-home/about/vision-1.webp";
import Yoursafety from "../../../public/updated-home/about/your-safety.webp";
import Tailoredservices from "../../../public/updated-home/about/tailored-services.webp";
import Professionalchauffeurs from "../../../public/updated-home/about/professional-chauffeurs.webp";
import Customercentric from "../../../public/updated-home/about/customer-centric.webp";
import Booking from "../../../public/updated-home/about/booking.webp";
import Image from "next/image";

function SliderIndicator({ index, activeIndex, onClick }) {
  return (
    <span
      onClick={() => onClick(index)}
      className={`h-2 w-2 bg-gray-500 rounded-full mx-1 display-desktop  cursor-pointer ${
        index === activeIndex ? "bg-[#D5AF34]" : "red"
      }`}
    />
  );
}

function Vision() {
  const contentData = [
    {
      title: "Unparalleled Fleet",
      subtitle: "Ride in Style",
      text: "Our diverse fleet boasts an array of high-end vehicles, from executive sedans to premium SUVs, all highly maintained to ensure the highest standards of comfort and safety. Whether you're looking to make a statement at a corporate event or want to create lasting memories on your special occasion, Prestige Ride has the perfect vehicle for you.",
      image: Vision1,
      alt: "Ride in Style",
      tle: "Ride in Style",
    },
    {
      title: "Professional Chauffeurs",
      subtitle: "Navigating Excellence",
      text: "To complement our exceptional fleet, we have a team of professional and experienced chauffeurs who are dedicated to making your journey a memorable one. With a deep knowledge of the roads, they ensure a smooth and comfortable ride, leaving you free to savor every moment of your luxurious transportation—professional chauffeurs for your professional trip. ",
      image: Professionalchauffeurs,
      alt: "Navigating Excellence",
      tle: "Navigating Excellence",
    },
    {
      title: "Uplifting Every Occasion",
      subtitle: " Tailored Services",
      text: "At Prestige Ride, we understand that every occasion is unique, and your journey should reflect that. Whether it's a corporate event, a business meeting, an airport transfer, or a night on the town, our services can be tailored to your needs, ensuring a smooth and elegant experience on every journey. At your service!",
      image: Tailoredservices,
      alt: "Tailored Services",
      tle: "Tailored Services",
    },
    {
      title: "Customer-Centric Approach",
      subtitle: " Your Satisfaction, Our Priority",
      text: "Customer satisfaction is at the core of our values. We take pride in providing exceptional services that meet and exceed your expectations. Our commitment to excellence is unwavering, ensuring that each ride with Prestige Ride is a remarkable one. We're dedicated to putting you at the center of every decision, making your satisfaction our priority.",
      image: Customercentric,
      alt: "Customer satisfaction",
      tle: "Customer satisfaction",
    },
    {
      title: "Unmatched Convenience ",
      subtitle: "Booking with Ease",
      text: "Our convenient online platform allows you to reserve your luxury car in just a few clicks. With transparent pricing and flexible options, we strive to make your experience with us as smooth as possible. Our goal is to take the stress out of travel planning and ensure that your experience with Prestige Ride is marked by convenience and ease.",
      image: Booking,
      alt: "Booking with Ease",
      tle: "Booking with Ease",
    },
    {
      title: "Secure and Reliable ",
      subtitle: "Your Safety Matters",
      text: "Prestige Ride places a premium on your safety and security. Our vehicles have the latest safety features, and our chauffeurs undergo rigorous training to ensure a safe journey every time you ride with us. We invest in advanced safety technology to monitor and enhance every ride, offering you peace of mind throughout your trip.",
      image: Yoursafety,
      alt: "Secure and Reliable",
      tle: "Secure and Reliable",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < contentData.length - 1 ? prevIndex + 1 : 0
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : contentData.length - 1
    );
  };

  const handleIndicatorClick = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    // Auto slide every 5 seconds
    const interval = setInterval(() => {
      handleNext();
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [currentIndex]);

  return (
    <div>
      <div className="mx-auto max-w-7xl  pt-12">
        <div className="text-center px-6">
          <h2 className="text-3xl secondary font-bold">
            The Legacy of Luxury:{" "}
            <span className="text-[#D5AF34]">Prestige Ride's Vision</span>
          </h2>
          <p className="updatedparapremu pt-4 mb-12">
            Prestige Ride has built a legacy of luxury that has become
            synonymous with our brand. With a keen eye for detail, we have
            meticulously designed our services to cater to the most discerning
            tastes. From the moment you step into one of our vehicles, you'll
            know you're in for an extraordinary experience. We've diligently
            crafted a fleet of exquisite vehicles, including black cars and
            high-end sedans, designed to make your journey a smooth blend of
            luxury and comfort.
          </p>
        </div>
      </div>

      {/* Center-aligned arrow icons */}

      <div className=" grid grid-cols-12 mb-10">
        <div className="col-span-1 display flex items-center justify-center">
          {" "}
          <div className="col-span-1">
            <Image
              src={left}
              height={20}
              width={20}
              alt="left arrow to slid"
              title="left arrow to slid"
              className="text-4xl text-[#D5AF34] cursor-pointer mr-4"
              onClick={handlePrev}
            />
          </div>
        </div>

        <div className=" px-6 col-span-12 sm:col-span-10 md:col-span-10 lg:col-span-10 ">
          <div className=" relative ">
            <div
              style={{ background: "rgba(245, 245, 245, 1)" }}
              className="mx-auto  px-[16px] visiontop  rounded-2xl lg:pb-10  max-w-7xl grid grid-cols-5  lg:gap-10  xl:px-10 relative"
            >
              <div className="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-2 ">
                <Image
                  src={contentData[currentIndex].image}
                  alt={contentData[currentIndex].alt}
                  title={contentData[currentIndex].tle}
                  width={940}
                  height={200}
                />
              </div>

              <div className="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-3 ">
                <h2 id="visionh2" className="text-3xl font-bold">
                  <span className="text-[#2b3252]">
                    {" "}
                    {contentData[currentIndex].title}
                  </span>
                  :{" "}
                  <span className="text-[#D5AF34]">
                    {contentData[currentIndex].subtitle}
                  </span>

                </h2>
             
                <p
          dangerouslySetInnerHTML={{ __html: contentData[currentIndex].text }}
          className="updatedparapremu pt-6"
        ></p>
              </div>

              {/* Indicators */}
              <div className="absolute bottom-4 left-0 right-0 flex justify-center">
                {contentData.map((_, index) => (
                  <SliderIndicator
                    key={index}
                    index={index}
                    activeIndex={currentIndex}
                    onClick={handleIndicatorClick}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="col-span-1 display flex items-center justify-center ">
          <div className="col-span-1 ">
            <Image
              src={right}
              height={20}
              width={20}
              alt="right arrow to slid"
              title="right arrow to slid"
              className="text-4xl text-[#D5AF34] cursor-pointer"
              onClick={handleNext}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Vision;
